<header class="flex items-center justify-between bg-[var(--app-background-level-2)] text-gray-100 p-4 sticky top-0 z-50">
	<div class="flex items-center">
	  <img src="/path-to-icon.png" alt="" class="w-8 h-8 mr-2">
	  <span class="text-xl font-bold">DeckBlox Streaming Games Dashboard</span>
	</div>
	<div class="flex items-center space-x-4">
	  <!-- Future actions will go here -->
	</div>
</header>